import * as React from 'react'
import { observer } from 'mobx-react'
import { ViewHeadingProps, ViewHeading } from 'components/ViewHeading'
import { Dropdown } from 'components/Dropdown'
import { SelectFilter } from 'infra/FilterControls/Select/SelectFilter'
import { SelectFilterView } from 'infra/FilterControls/Select'
import { IFilterViewModel } from 'infra/FiltersViewModel'

interface WorkspaceFilterViewHeadingProps
  extends Omit<ViewHeadingProps, 'isDropdown' | 'secondaryText'> {
  filter: IFilterViewModel<string, unknown>
  allOptionText?: string
}

export default observer(function WorkspaceFilterViewHeading({
  filter,
  allOptionText = 'All Workspaces',
  ...rest
}: WorkspaceFilterViewHeadingProps) {
  if (!(filter instanceof SelectFilter)) {
    return <>Filter type not supported</>
  }

  const heading = (
    <ViewHeading
      {...rest}
      isDropdown={true}
      secondaryText={
        filter.value.length >= 1 ? filter.toString(1) : allOptionText
      }
    />
  )
  return (
    <Dropdown
      isOpen={filter.editing}
      position={'top-start'}
      onRequestClose={filter.stopEditing}
      onButtonClick={filter.startEditing}
      button={heading}
    >
      <SelectFilterView filter={filter} />
    </Dropdown>
  )
})
